import { FormattedMessage } from 'react-intl';
import React from 'react';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import GiftCard1 from 'components/GiftCard1';
import * as styles from './styles/styles.module.scss';

const { REDEEM_YOUR_SUBSCRIPTION } = StringConstantsMixin.strings.REDEMPTION_PAGE;

const RedemptionHeader = () => (
  <main className={styles.heroContainer}>
    <div className={styles.contentContainer}>
      <h1 className={styles.heroMessage}>
        <FormattedMessage
          defaultMessage={REDEEM_YOUR_SUBSCRIPTION}
          id={REDEEM_YOUR_SUBSCRIPTION}
          values={{ span: chunks => <span>{chunks}</span> }}
        />
      </h1>
      <div className={styles.giftCards}>
        <GiftCard1 />
      </div>
    </div>
  </main>
);

export default RedemptionHeader;
